import { createRouter, createWebHistory } from 'vue-router';

const routes = [

    {
        path: '/',
        component: () =>
            import ('../pages/auth/login.vue'),
        name: 'admin.login',

    }, {
        path: '/home',
        component: () =>
            import ('../pages/Home.vue'),
        children: [{
                path: '/home',
                component: () =>
                    import ('../pages/dashboard/Dashboard.vue'),
                name: 'admin.dashboard.home',
                meta: {
                    nav: 'home'
                }

            },




            /**
             * Subscribers
             */
            {
                path: '/subscribers/list',
                component: () =>
                    import ('../pages/dashboard/SubscribersManagement/SubscribersList.vue'),
                name: 'admin.dashboard.subscribers.list',
                meta: {
                    nav: 'subscribers'
                }

            },
            {
                path: '/subscriber/:id',
                component: () =>
                    import ('../pages/dashboard/SubscribersManagement/SubscriberDetails.vue'),
                name: 'admin.dashboard.subscriber.details',
                meta: {
                    nav: 'subscribers'
                }
            },

            /**
             * Games
             */


            {
                path: '/games/list',
                component: () =>
                    import ('../pages/dashboard/GamesManagement/GamesList.vue'),
                name: 'admin.dashboard.games.list',
                meta: {
                    nav: 'games'
                }

            },
            {
                path: '/game/form',
                component: () =>
                    import ('../pages/dashboard/GamesManagement/GameForm.vue'),
                name: 'admin.dashboard.game.create',
                meta: {
                    nav: 'games'
                }

            },
            {
                path: '/game/edit/:id',
                component: () =>
                    import ('../pages/dashboard/GamesManagement/GameForm.vue'),
                name: 'admin.dashboard.game.edit',
                meta: {
                    nav: 'games'
                }

            },


            {
                path: '/game/details/:id',
                component: () =>
                    import ('../pages/dashboard/GamesManagement/GameDetails.vue'),
                name: 'admin.dashboard.game.details',
                meta: {
                    nav: 'games'
                }
            },

            /**
             * News
             */
            {
                path: '/news/list',
                component: () =>
                    import ('../pages/dashboard/NewsManagement/NewsList.vue'),
                name: 'admin.dashboard.news.list',
                meta: {
                    nav: 'news'
                }

            },
            {
                path: '/news/form',
                component: () =>
                    import ('../pages/dashboard/NewsManagement/NewsForm.vue'),
                name: 'admin.dashboard.news.create',
                meta: {
                    nav: 'news'
                }

            },
            {
                path: '/news/edit/:id',
                component: () =>
                    import ('../pages/dashboard/NewsManagement/NewsForm.vue'),
                name: 'admin.dashboard.news.edit',
                meta: {
                    nav: 'news'
                }

            },

            /**
             * discussions
             */
            {
                path: '/discussions/list',
                component: () =>
                    import ('../pages/dashboard/DiscussionManagement/DiscussionsList.vue'),
                name: 'admin.dashboard.discussions.list',
                meta: {
                    nav: 'discussions'
                }

            },
            {
                path: '/discussions/:id',
                component: () =>
                    import ('../pages/dashboard/DiscussionManagement/DiscussionsForm.vue'),
                name: 'admin.dashboard.discussions.edit',
                meta: {
                    nav: 'discussions'
                }

            },
            {
                path: '/discussions/:id/comments',
                component: () =>
                    import ('../pages/dashboard/DiscussionManagement/Comments/CommentsList.vue'),
                name: 'admin.dashboard.discussions.comments',
                meta: {
                    nav: 'discussions'
                }

            },
            {
                path: '/discussions/reports/list',
                component: () =>
                    import ('../pages/dashboard/DiscussionManagement/Reports/DiscussionsList.vue'),
                name: 'admin.dashboard.discussions.reports.list',
                meta: {
                    nav: 'discussions.reports'
                }

            },
            {
                path: '/discussions/comments/reports/list',
                component: () =>
                    import ('../pages/dashboard/DiscussionManagement/Reports/DiscussionCommentsList.vue'),
                name: 'admin.dashboard.discussions.comments.reports.list',
                meta: {
                    nav: 'discussions.comments.reports'
                }

            },

            {
                path: '/giveaways/list',
                component: () =>
                    import ('../pages/dashboard/GiveawaysManagement/GiveawaysList.vue'),
                name: 'admin.dashboard.giveaways.list',
                meta: {
                    nav: 'giveaways'
                }

            },

            /**
             * Stories
             */
            {
                path: '/stories/list',
                component: () =>
                    import ('../pages/dashboard/GameStoryManagement/GameStoryList.vue'),
                name: 'admin.dashboard.stories.list',
                meta: {
                    nav: 'stories'
                }

            },
            {
                path: '/stories/form',
                component: () =>
                    import ('../pages/dashboard/GameStoryManagement/GameStoryForm.vue'),
                name: 'admin.dashboard.story.create',
                meta: {
                    nav: 'stories'
                }

            },
            {
                path: '/story/edit/:id',
                component: () =>
                    import ('../pages/dashboard/GameStoryManagement/GameStoryForm.vue'),
                name: 'admin.dashboard.story.edit',
                meta: {
                    nav: 'stories'
                }

            },
            /**
             * Game Trailers
             */
            {
                path: '/game/trailers/list',
                component: () =>
                    import ('../pages/dashboard/GameTrailerManagement/GameTrailerList.vue'),
                name: 'admin.dashboard.game.trailers.list',
                meta: {
                    nav: 'trailers'
                }

            },
            {
                path: '/game/trailer/form',
                component: () =>
                    import ('../pages/dashboard/GameTrailerManagement/GameTrailerForm.vue'),
                name: 'admin.dashboard.game.trailer.create',
                meta: {
                    nav: 'trailers'
                }

            },
            {
                path: '/game/trailer/edit/:id',
                component: () =>
                    import ('../pages/dashboard/GameTrailerManagement/GameTrailerForm.vue'),
                name: 'admin.dashboard.game.trailer.edit',
                meta: {
                    nav: 'trailers'
                }

            },
            /**
             * Game Activities
             */
            {
                path: '/game/activities/list',
                component: () =>
                    import ('../pages/dashboard/GameActivityManagement/GameActivityList.vue'),
                name: 'admin.dashboard.game.activities.list',
                meta: {
                    nav: 'activities'
                }

            },
            {
                path: '/game/activity/form',
                component: () =>
                    import ('../pages/dashboard/GameActivityManagement/GameActivityForm.vue'),
                name: 'admin.dashboard.game.activity.create',
                meta: {
                    nav: 'activities'
                }

            },
            {
                path: '/game/activity/edit/:id',
                component: () =>
                    import ('../pages/dashboard/GameActivityManagement/GameActivityForm.vue'),
                name: 'admin.dashboard.game.activity.edit',
                meta: {
                    nav: 'activities'
                }

            },

            /**
             * Users
             */

            {
                path: '/users/list',
                component: () =>
                    import ('../pages/dashboard/UsersManagement/UsersList.vue'),
                name: 'admin.dashboard.users.list',
                meta: {
                    nav: 'users'
                }

            },
            {
                path: '/user/details/:id',
                component: () =>
                    import ('../pages/dashboard/UsersManagement/UserDetails.vue'),
                name: 'admin.dashboard.user.details',
                meta: {
                    nav: 'users'
                }
            },
            {
                path: '/user/create',
                component: () =>
                    import ('../pages/dashboard/UsersManagement/UserForm.vue'),
                name: 'admin.dashboard.user.create',
                meta: {
                    nav: 'users'
                }
            },
            {
                path: '/user/edit/:id',
                component: () =>
                    import ('../pages/dashboard/UsersManagement/UserForm.vue'),
                name: 'admin.dashboard.user.edit',
                meta: {
                    nav: 'users'
                }
            },


            /**
             * Game Categories
             */
            {
                path: '/game/categories/list',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/GameCategoriesManagement/GameCategoriesList.vue'),
                name: 'admin.dashboard.game.categories.list',
                meta: {
                    nav: 'settings'
                }

            },
            {
                path: '/game/category/form',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/GameCategoriesManagement/GameCategoryForm.vue'),
                name: 'admin.dashboard.game.category.create',
                meta: {
                    nav: 'settings'
                }

            },
            {
                path: '/game/category/edit/:id',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/GameCategoriesManagement/GameCategoryForm.vue'),
                name: 'admin.dashboard.game.category.edit',
                meta: {
                    nav: 'settings'
                }

            },
            /**
             * CPUs
             */
            {
                path: '/cpus/list',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/CpusManagement/CpusList.vue'),
                name: 'admin.dashboard.cpus.list',
                meta: {
                    nav: 'settings.cpus'
                }

            },
            {
                path: '/cpu/form',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/CpusManagement/CpuForm.vue'),
                name: 'admin.dashboard.cpu.create',
                meta: {
                    nav: 'settings.cpus'
                }
            },
            {
                path: '/cpu/edit/:id',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/CpusManagement/CpuForm.vue'),
                name: 'admin.dashboard.cpu.edit',
                meta: {
                    nav: 'settings.cpus'
                }
            },

            /**
             * gpu
             */
            {
                path: '/gpus/list',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/GpusManagement/GpusList.vue'),
                name: 'admin.dashboard.gpus.list',
                meta: {
                    nav: 'settings.gpus'
                }
            },
            {
                path: '/gpu/form',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/GpusManagement/GpuForm.vue'),
                name: 'admin.dashboard.gpu.create',
                meta: {
                    nav: 'settings.gpus'
                }
            },
            {
                path: '/gpu/edit/:id',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/GpusManagement/GpuForm.vue'),
                name: 'admin.dashboard.gpu.edit',
                meta: {
                    nav: 'settings.gpus'
                }
            },
            /**
             * ram
             */
            {
                path: '/rams/list',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/RamManagement/RamList.vue'),
                name: 'admin.dashboard.ram.list',
                meta: {
                    nav: 'settings.rams'
                }
            },
            {
                path: '/ram/form',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/RamManagement/RamForm.vue'),
                name: 'admin.dashboard.ram.create',
                meta: {
                    nav: 'settings.rams'
                }
            },
            {
                path: '/ram/edit/:id',
                component: () =>
                    import ('../pages/dashboard/SettingsManagement/RamManagement/RamForm.vue'),
                name: 'admin.dashboard.ram.edit',
                meta: {
                    nav: 'settings.rams'
                }
            },
            /**
             * Payments
             */
            {
                path: '/payments/list',
                component: () =>
                    import ('../pages/dashboard/PaymentManagement/PaymentList.vue'),
                name: 'admin.dashboard.payments.list',
                meta: {
                    nav: 'payments'
                }

            },
            {
                path: '/payment/form',
                component: () =>
                    import ('../pages/dashboard/PaymentManagement/PaymentForm.vue'),
                name: 'admin.dashboard.payment.create',
                meta: {
                    nav: 'payments'
                }
            },
            {
                path: '/payment/edit/:id',
                component: () =>
                    import ('../pages/dashboard/PaymentManagement/PaymentForm.vue'),
                name: 'admin.dashboard.payment.edit',
                meta: {
                    nav: 'payments'
                }
            },



            {
                path: '/igdb/events/list',
                component: () =>
                    import ('../pages/dashboard/GamesManagement/igdb/Events/EventList.vue'),
                name: 'admin.dashboard.igdb.events.list',
                meta: {
                    nav: 'igdb.events'
                }
            },


            {
                path: '/igdb/games/list',
                component: () =>
                    import ('../pages/dashboard/GamesManagement/igdb/Games/GamesList.vue'),
                name: 'admin.dashboard.igdb.games.list',
                meta: {
                    nav: 'igdb.games'
                }
            },
            {
                path: '/igdb/webhook/games/list',
                component: () =>
                    import ('../pages/dashboard/GamesManagement/igdb/Games/WebhookGamesList.vue'),
                name: 'admin.dashboard.igdb.webhook.games.list',
                meta: {
                    nav: 'igdb.games.webhook'
                }
            },
            {
                path: '/igdb/webhook/logs/games/list',
                component: () =>
                    import ('../pages/dashboard/GamesManagement/igdb/Games/WebhookLogsGamesList.vue'),
                name: 'admin.dashboard.igdb.webhook.logs.games.list',
                meta: {
                    nav: 'igdb.games.webhook.logs'
                }
            },

            {
                path: '/analytics/visitors',
                component: () =>
                    import ('../pages/dashboard/AnalyticsVisitors.vue'),
                name: 'admin.dashboard.analytics.visitors',
                meta: {
                    nav: 'analytics.visitors'
                }
            },







        ],

    },


]

const router = createRouter({
    routes,
    history: createWebHistory()
})



export default router